<template>
  <div class="import-pay-modal">
    <el-dialog
      title="导入缴费记录"
      :visible.sync="visible"
      width="600px"
      append-to-body
      class="import-pay"
      :before-close="handleCancel"
      :close-on-click-modal="false"
    >
      <div class="import-content">
        <el-button class="download-btn" :loading="downloadLoading" @click="downloadTemplate"
          >下载导入模板</el-button
        >
        <el-upload
          ref="upload"
          class="upload-area"
          action=""
          accept=".xls,.xlsx"
          :show-file-list="false"
          :http-request="handleUpload"
        >
          <div class="upload-trigger">
            <i class="el-icon-plus"></i>
            <span class="upload-text">上传</span>
          </div>
        </el-upload>
        <p class="upload-tip">仅支持excel文件</p>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleCancel">关闭</el-button>
      </span>
    </el-dialog>
    <PayErrorMsg ref="PayErrorMsg"></PayErrorMsg>
    <PayCheckMsg ref="PayCheckMsg" @continue="handleContinueImport"></PayCheckMsg>
  </div>
</template>

<script>
import { payRecordDownLoad, payRecordCheck, payRecordImport } from '@/api/certificate'
import to from 'await-to'
import PayErrorMsg from './PayErrorMsg'
import PayCheckMsg from './PayCheckModal'
export default {
  name: 'ImportPayModal',
  components: {
    PayErrorMsg,
    PayCheckMsg,
  },
  data() {
    return {
      visible: false,
      downloadLoading: false,
      pendingParams: null,
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    async handleUpload(file) {
      if (!/\.(xls|xlsx)$/i.test(file.file.name)) {
        return this.$message.warning('仅支持excel文件')
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const params = new FormData() //创建FormData
      params.append('file', file.file)
      this.pendingParams = params
      const [, err] = await to(payRecordCheck(params))
      loading.close()
      if (err) return this.$refs.PayCheckMsg.show(err.msg)

      await this.doImport(params)
    },
    async handleContinueImport() {
      if (!this.pendingParams) return
      await this.doImport(this.pendingParams)
    },
    async doImport(params) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const [res, err] = await to(payRecordImport(params))
      loading.close()
      if (err) return this.$refs.PayErrorMsg.show(err.msg)
      this.$message.success(res.data)
      this.handleCancel()
      this.$emit('success')
    },
    async downloadTemplate() {
      if (this.downloadLoading) return
      this.downloadLoading = true
      const [res, err] = await to(payRecordDownLoad())
      this.downloadLoading = false
      if (err) return this.$message.warning(err.msg)
      const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
      if (window.navigator.msSaveOrOpenBlob) {
        //兼容IE10
        navigator.msSaveBlob(blob, this.filename)
      } else {
        const href = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = href
        a.download = '缴费记录导入模板'
        a.click()
        URL.revokeObjectURL(a.href)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.import-pay {
  ::v-deep .el-dialog__body {
    padding: 30px 20px;
  }
  ::v-deep .el-dialog__footer {
    padding: 10px 20px 20px;
    text-align: right;
  }
  .import-content {
    padding-left: 20px;
    .download-btn {
      margin-bottom: 24px;
    }
    .upload-area {
      ::v-deep .el-upload {
        width: 100px;
        height: 100px;
      }
      .upload-trigger {
        position: relative;
        width: 100px;
        height: 100px;
        background: #fafbfc;
        border: 1px dashed #d9d9d9;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: border-color 0.2s;
        &:hover {
          border-color: #409eff;
        }
        .upload-tag {
          position: absolute;
          top: -10px;
          right: -8px;
          padding: 0 6px;
          background: #ffc60b;
          border-radius: 4px;
          font-size: 12px;
          line-height: 18px;
          color: #fff;
        }
        .el-icon-plus {
          font-size: 28px;
          color: #606266;
          line-height: 1;
        }
        .upload-text {
          margin-top: 8px;
          font-size: 14px;
          color: #606266;
        }
      }
    }
    .upload-tip {
      margin: 8px 0 0;
      font-size: 12px;
      color: #909399;
    }
  }
  .dialog-footer {
    ::v-deep .el-button {
      min-width: 90px;
    }
  }
}
</style>
